"use client";

import { createContext, useContext } from "react";
import { PageContextProviderProps, PageContextSchema } from "./schema";

const ClientContext = createContext<PageContextSchema | null>(null);

const ClientContextProvider: React.FC<PageContextProviderProps> = ({
    data,
    children,
}) => <ClientContext.Provider value={data || null}>{children}</ClientContext.Provider>;

export const usePageClientContext = () => {
    return useContext(ClientContext);
};

export default ClientContextProvider;
